import {
  QUANTUM,
  QUANTUM_DEMO,
  ENSEMBLE,
  ENSEMBLE_PROVIDER_LOOKUP,
  POLK,
  LIFEPOINT,
  COVENANTHEALTH,
  CHILDRENSTEXAS,
  ROPESGRAY,
  NORTHROPGRUMMAN,
  EmboldClientIdentifier,
} from 'utils/constants';
import quantumThemeVariant from './quantumThemeVariant';
import lifepointThemeVariant from './lifepointThemeVariant';
import testThemeVariant from './testThemeVariant';
import quantumSandboxThemeVariant from './quantumSandboxThemeVariant';
import type { PartialThemeOverrides } from './themeVariants.types';

export const DEFAULT = 'default' as const;
export const TEST_VARIANT = 'test theme variant' as const;

type ThemeVariantContent = { name: string; spec: PartialThemeOverrides };
type ThemeVariantMap = {
  [DEFAULT]: ThemeVariantContent;
  [TEST_VARIANT]: ThemeVariantContent;
} & Partial<Record<EmboldClientIdentifier, ThemeVariantContent>>;
export type ThemeVariantMapKey = keyof ThemeVariantMap;

export const CLIENT_THEME_VARIANT_MAP: ThemeVariantMap = {
  [QUANTUM]: {
    name: 'quantum',
    spec: quantumThemeVariant,
  },
  [QUANTUM_DEMO]: {
    name: 'quantum',
    spec: quantumSandboxThemeVariant,
  },
  [DEFAULT]: {
    name: DEFAULT,
    spec: {},
  },
  [TEST_VARIANT]: {
    name: TEST_VARIANT,
    spec: testThemeVariant,
  },
  [ENSEMBLE]: {
    name: 'ensemble',
    spec: quantumThemeVariant,
  },
  [ENSEMBLE_PROVIDER_LOOKUP]: {
    name: 'ensemble-providerlookup',
    spec: quantumThemeVariant,
  },
  [POLK]: {
    name: 'polk',
    spec: quantumThemeVariant,
  },
  [LIFEPOINT]: {
    name: 'lifepoint',
    spec: lifepointThemeVariant,
  },
  [COVENANTHEALTH]: {
    name: 'covenanthealth',
    spec: quantumThemeVariant,
  },
  [CHILDRENSTEXAS]: {
    name: 'childrenstexas',
    spec: quantumThemeVariant,
  },
  [ROPESGRAY]: {
    name: 'ropesgray',
    spec: quantumThemeVariant,
  },
  [NORTHROPGRUMMAN]: {
    name: 'northropgrumman',
    spec: quantumThemeVariant,
  },
};
